<script>
  import { TopBar } from '@/components/_shared'

  export default {
    name: 'schedules-view',

    components: {
      TopBar
    },

    metaInfo: {
      title: 'Schedules'
    }
  }
</script>

<template>
  <div>
    <top-bar title="Schedules" icon="clock"/>
    <b-container fluid></b-container>
  </div>
</template>
